require('./detail.less');

var ajax = require('@enhancer/fe-util-ajax');
var locale = require('./i18n');
var util = require('../../app/util');
var app = require('../../app/app');
var homeTpl = require('./detail.html');

var pageConfig = window.pageConfig;
var path = pageConfig.path;
var inFrame = window.parent != window;

window.enhancer = window.enhancer || {};




var validateObj;
function loadEnhancerCaptcha(cb) {
  if (window.EnhancerCaptcha) {
    validateCaptcha(cb);
  } else {
    var url = `//${location.hostname.replace(/^[^.]+/, 'assets')}`
    url = url.replace('.local', '.cc');
    util.getScript(url + '/vendor/geetest/all/gt.js', () => {
      validateCaptcha(cb);
    });
  }
}
function validateCaptcha(cb) {
  if (validateObj) {
    validateObj.captchaObj.reset();
    return cb();
  }
  validateObj = new window.EnhancerCaptcha({
    geetest: {
      product: 'popup',
      lang: decodeURIComponent(util.getCookie('lang') || ''),
      width: "320px"
    },
    ready: function() {
      validateObj.captchaObj.onSuccess(function() {
        $('#captcha').hide();
        getActiveCode()
      });
    }
  });
  validateObj.render();
  cb();
}
function getActiveCode () {
  var mobile = $('#mobile').val().trim();
  if (util.isMobile(mobile)) {
    var data = validateObj.getValidate();
    if (!data) {
      return
    }
    data.mobile = mobile;
    util.getActiveCode($('#getActiveCode'), data, function () { });
  } else {
    util.show(locale('mobileInvalid'))
  }
}

function dataURLtoFile(dataurl, filename) {
  var arr = dataurl.split(',');
  var mime = arr[0].match(/:(.*?);/)[1];
  var binary = atob(arr[1]);
  var array = [];
  for(var i = 0; i < binary.length; i++) {
      array.push(binary.charCodeAt(i));
  }
  return new Blob([new Uint8Array(array)], {type: mime});
}


function onCredential(res, src, cb) {
  var params = res.credential.params;
  var formData = new FormData();
  var file = dataURLtoFile(src, 'avatar.png');
  var url = res.credential.host + '/' + params.key;
  if (url.length > 255) {
    util.show('头像url长度不能超过255')
    return
  }

  formData.append('key', params.key);
  formData.append('policy', params.policy);
  formData.append('OSSAccessKeyId', params.OSSAccessKeyId);
  formData.append('success_action_status', params.success_action_status);
  formData.append('signature', params.signature);
  formData.append('file', file);

  var xhr = new window.XMLHttpRequest();
  xhr.open('POST', res.credential.host);
  xhr.send(formData); //发送表单数据  
  xhr.onreadystatechange = () => { //在这里指定上传成功的回调函数，接受返回值  
    if (xhr.readyState == 4) {
      if (xhr.status == 200) {
        cb(res.credential.host + '/' + params.key);
      } else {
        console.log(xhr);
      }
    }
  }

  /*
  ajax({
      url: res.credential.host,
      type: 'POST',
      data: formData,
      headers: {"Access-Control-Allow-Origin": location.host}
      ,processData: false
      //,contentType: false
      //,crossDomain: true
  }, function () {
      onFileLink(res.credential.host + '/' + params.key)
  });
  */
}




function init() {
  enhancer.setAvatar = function(src) {
    $('.image-crop .close').click();
    $('.user-avatar img').prop('src', src);
    $('input[name=avatar]').val(src);
    saveData($('input[name="avatar"]').parent());
  }

  function enhancerChangeAvatarState (op) {
    //$('.container')[op + 'Class' ]('pt80');
    //$('.user-avatar')[op + 'Class' ]('hide');
  }

  $('.btn-edit').click(function(e) {
    e.preventDefault();

    //$('.user-info').addClass('edit-mode');
    $('.user-info').addClass('change-pass');

    if (inFrame) {
      enhancerChangeAvatarState('remove');
    }
  });

  var accountCache = {};
  var loading = false;
  function checkNickNameExist (nickname, cb) {
    if (accountCache[nickname]) {
      cb(null, accountCache[nickname]);
    } else {
      if (loading) {
        return
      }
      loading = true;
      ajax({
        type: 'GET',
        url:  '/api/nickname?nickname=' + encodeURIComponent(nickname)
      }, function (res) {
        loading = false;
        if (res.success) {
          if (res.exist) {
            accountCache[nickname] = 2;
          } else {
            accountCache[nickname] = 1;
          }
          cb(null, accountCache[nickname]);
        } else {
          util.show(res.message);
          console.log(res);
        }
      }, function (err) {
        loading = false;
        cb(err);
      });
    }
  }

  var validate = window.pageConfig.validate;

  $('#email').on('blur', function () {
    var val = $(this).val().trim();
    var ele = $(this);
    if (!util.isEmail(val)) {
      ele.parent().find('label.error-msg').text(locale('emailInvalid'));
      ele.addClass('error');
      return
    }
  }).on('focus', function () {
    $(this).removeClass('error');
  })
  $('#mobile').on('blur', function () {
    var val = $(this).val().trim();
    var ele = $(this);
    if (!util.isMobile(val)) {
      ele.parent().find('label.error-msg').text(locale('mobileInvalid'));
      ele.addClass('error');
      return
    }
  }).on('focus', function () {
    $(this).removeClass('error');
  })
  $('#nickname').on('blur', function () {
    var val = $(this).val().trim();
    var focusValue = $(this).data('focusValue');
    var oldValue = $(this).attr('oldValue');
    var ele = $(this);

    if (val === oldValue) {
      return;
    }

    if (val.length > validate.nicknameMaxLength) {
      ele.parent().find('label.error-msg').text(locale('nicknameLong', {
        max: validate.nicknameMaxLength
      }));
      ele.addClass('error');
      return
    }
    if (val.length < validate.nicknameMinLength) {
      ele.parent().find('label.error-msg').text(locale('nicknameShort', {
        min: validate.nicknameMinLength
      }));
      ele.addClass('error');
      return
    }
    if (val.length < 4) {
      for (var i = 0; i < val.length; i++) {
        if (val.charCodeAt(i) < 255) {
          ele.parent().find('label.error-msg').text(locale('nicknameShort', {
            min: validate.nicknameMinLength
          }));
          ele.addClass('error');
          return
        }
      }
    }
    if (accountCache[val] == 2) {
      ele.parent().find('label.error-msg').text(locale('nicknameExists'));
      ele.addClass('error');
      return
    }
    if (val && val !== focusValue) {
      checkNickNameExist(val, function (err, type) {
        if (type === 2) {
          ele.parent().find('label.error-msg').text(locale('nicknameExists'));
          ele.addClass('error');
        } else {
          ele.removeClass('error');
        }
      })
    }
  }).on('focus', function () {
    $(this).data('focusValue', $(this).val().trim());
    $(this).removeClass('error');
  });
  $('input[name=company],input[name=address],input[name=description],input[name=website]').on('blur', function () {
    var val = $(this).val().trim();
    var ele = $(this);
    var name = ele.attr('name')
    var max = name == 'website' ? 255 : 64;
    var title = ele.closest('tr').find('td:first').text().trim().replace(/\:$/, '');

    if (val.length > max) {
      ele.parent().find('label.error-msg').text(locale('lengthLong', {name: title, max: max}));
      ele.addClass('error');
      return
    }
  }).on('focus', function () {
    $(this).removeClass('error');
  })



  $('.btn-save').click(function(e) {
    e.preventDefault();
    saveData($('#password').closest('tr'));
  });

  $('.btn-cancel').click(function(e) {
    e.preventDefault();
    cancelSavePass();
    if (inFrame) {
      enhancerChangeAvatarState('add');
    }
  });

  $('.user-avatar .avatar-tip').click(function() {
    $('.user-avatar input[type=file]').click();
  });


  $('.user-avatar input[type=file]').on('change', function(e) {
    var files = e.target.files;
    [].forEach.call(files, function(item) {
      if (item.type.match('image.*')) {
        var src = URL.createObjectURL(item);
        showCrop(src);
      }
    });
    this.value = '';
  });

  function showCrop(src) {
    var iframe = $('.image-crop iframe');

    if (iframe.length) {
      var child = iframe[0].contentWindow;
      if (iframe.data('loaded') && child.enhancer && child.enhancer.setImage) {
        child.enhancer.setImage(src);
        $('.image-crop, .mask').show();
      } else {
        setTimeout(function() {
          showCrop(src);
        }, 1000);
      }
    } else {
      iframe = document.createElement('iframe');
      $(iframe).on('load', function() {
        $(iframe).data('loaded', true);
        showCrop(src);
      });
      iframe.src = "/crop";
      $('.image-crop').append(iframe);
    }
  }

  $('.image-crop .close').click(function() {
    $('.image-crop, .mask').hide();
    var ele = $('[name=avatar]');
    ele.parent().find('img').attr('src', ele.attr('oldValue'))
  });

  

  $('#getActiveCode').click(function (e) {
    e.preventDefault();
    var mobile = $('#mobile').val().trim();
    if (util.isMobile(mobile)) {
      loadEnhancerCaptcha(() => {
        $('#captcha').show();
      })
    } else {
      util.show(locale('mobileInvalid'))
    }
  });






  $('.user-info .fa-pencil').click(function (e) {
    const target = $(e.currentTarget);
    e.preventDefault();
    target.closest('tr').addClass('edit-single');
  });
  $('.user-info').on('click', '.single-cancel', function (e){
    const target = $(e.currentTarget);
    cancelSave(target.closest('tr'));
  });

  $('.user-info').on('click', '.single-save', function (e){
    const target = $(e.currentTarget);
    saveData(target.closest('tr'))
  });

  function cancelSavePass() {
    const tr = $('#password').closest('tr');
    tr.find('.edit-data').val('');
    tr.next('tr').find('.edit-data').val('');
    $('.user-info').removeClass('change-pass');
  }

  function cancelSave(tr) {
    const edit = tr.find('.edit-data');
    tr.removeClass('edit-single');
    edit.val(edit.attr('oldValue'));
    edit.removeClass('error');
    tr.find('label.error-msg').text('');
    tr.find('.extra-edit').val('');
    const name = edit.prop('name') 
    if (name === 'mobile') {
      tr.next('tr').find('.extra-edit').val('');
    }
  }

  function saveData(tr) {
    const edit = tr.find('.edit-data');

    if (edit.hasClass('error')) {
      return
    }

    var save = {};
    var val = edit.val().trim();
    var old = edit.attr('oldValue');
    const name = edit.prop('name');
    if (old != val && val) {
      save[name] = val;
      if (name === 'email' || name === 'mobile') {
        save.password = tr.find('input[name=password]').val().trim();
        if (name === 'mobile') {
          save.mobileCode = $('input[name=mobileCode]').val().trim();
        }
      }
      if (name === 'password') {
        save.newPassword = $('input[name=newPassword]').val().trim();
      }
    } else {
      if (name === 'avatar' && val) {
        save.avatar = $('input[name=avatar]').val();
      } else {
        cancelSave(tr);
        return
      }
      
    }

    if (save.mobile) {
      if (!util.isMobile(save.mobile)) {
        return util.show(locale('mobileInvalid'))
      }

      if (!util.isPassword(save.password)) {
        return util.show(locale('passwordLength'))
      }

      if (!util.isActiveCode(save.mobileCode)) {
        return util.show(locale('mobileCodeInvalid'))
      }
    }


    function submit () {
      ajax({
        type: 'POST',
        data: save,
        url: '/api/userinfo'
      }, function(res) {
        if (res.success) {
          if (save.email) {
            //window.location.heref = 'https://mail.' + save.email.substring(save.email.lastIndexOf('@') + 1);
            util.show('请前往邮箱激活您的账号', '', function () {
              window.location.reload();
            });
            return
          }

          if (save.avatar) {
            var ele = $('[name=avatar]');
            ele.attr('oldValue', save.avatar);
            ele.parent().find('img').attr('src', save.avatar).attr('oldValue', save.avatar)
             
            $('.header .user-info .avatar-on-head').attr('src', save.avatar);
            if (inFrame) {
              $('.header .user-info .avatar-on-head', window.parent).attr('src', save.avatar);
              $('.user-avatar img', window.parent).attr('src', save.avatar);
            }
            return
          }
          
          const newPassword = save.newPassword;
          delete save.mobileCode;
          delete save.password;
          delete save.newPassword;

          for (var i in save) {
            var ele = $('[name=' + i + ']');
            ele.attr('oldValue', save[i]);
            ele.parent().find('.info-data span').text(save[i]);
          }

          if (newPassword) {
            cancelSavePass();
            return
          }

          cancelSave(tr);


          if (save.nickname) {
            $('.header .user-info .nick-name').text(save.nickname);
            $('.user-info .nickname').text(save.nickname);
          }

          if (save.nickname) {
            $('.header .user-info .nick-name').text(save.nickname)
            if (inFrame) {
              $('.header .user-info .nick-name', window.parent).text(save.nickname);
              $('.user-avatar div', window.parent).text(save.nickname);
            }
          }
          if (inFrame) {
            enhancerChangeAvatarState('add')
          }
        } else {
          if (save.avatar) {
            $('.image-crop .close').click();
          }
          util.show(res.message);
        }
      });
    }


    var errMessage = '';
    var checkMap = {
      email: function (cb) {
        if (!util.isEmail(save.email)) {
          errMessage = locale('emailInvalid')
          return true
        }
        if (!save.password) {
          errMessage = '请输入当前密码'
          return true
        }
        cb()
      },
      mobile: function (cb) {
        if (!util.isMobile(save.mobile)) {
          errMessage = '手机号格式不正确'
          return true
        }
        if (!save.password) {
          errMessage = '请输入当前密码'
          return true
        }
        if (!save.mobileCode) {
          errMessage = '请输入验证码'
          return true
        }
        cb()
      },
      company: function (cb) {
        if (save.company && save.company.length > 64) {
          errMessage = '公司名称长度不能超过 64';
          return true
        }
        cb()
      }, 
      address: function (cb) {
        if (save.address && save.address.length > 64) {
          errMessage = '所在区域长度不能超过 64';
          return true
        }
        cb()
      }, 
      description: function (cb) {
        if (save.description && save.description.length > 64) {
          errMessage = '个人描述长度不能超过 64';
          return true
        }
        cb()
      }, 
      website: function (cb) {
        if (save.website && save.website.length > 255) {
          errMessage = '个人网站长度不能超过 255';
          return true
        }
        cb()
      }, 
      nickname: function (cb) {
        if (save.nickname.length > validate.nicknameMaxLength) {
          errMessage = '用户名长度不能超过 ' + validate.nicknameMaxLength;
          return true;
        }
        if (save.nickname.length < validate.nicknameMinLength) {
          errMessage = '用户名长度不能小于 ' + validate.nicknameMinLength;
          return true;
        }
        if (save.nickname.length < 4) {
          var nickname = save.nickname;
          for (var i = 0; i < nickname.length; i++) {
            if (nickname.charCodeAt(i) < 255) {
              errMessage = '英文名称长度不能小于 4';
              return true
            }
          }
        }
        if (accountCache[save.nickname] == 2) {
          errMessage = locale('nicknameExists')
          return true
        }

        if (accountCache[save.nickname]) {
          cb();
          return
        }
        setTimeout(function () {
          cb();
        }, 1000);
      },
      newPassword: function (cb) {
        var val = save.newPassword;
        if (val.length < validate.passwordMinLength || val.length > validate.passwordMaxLength) {
          errMessage = '密码长度必须在 ' + validate.passwordMinLength + ' - ' + validate.passwordMaxLength + ' 之间';
          return true
        }
        if (!save.password) {
          errMessage = '请输入当前密码'
          return true
        }
        //cb()
        return cb();
      },
      avatar: function (cb) {
        if (save.avatar.indexOf('//') === 0) {
          return cb();
        }
        ajax({
          url: '/api/osscredential'
        }, function(res) {
          if (!res.success) {
            return util.show(res.message);
          }
          onCredential(res, save.avatar, function (url) {
            save.avatar = url;
            cb();
          });
        });
      }
    }

    var count = 0;
    var keys = Object.keys(save);
    function addCount() {
      count++;
      if (count === keys.length) {
        submit();
      }
    }

    var result = keys.some(function (key) {
      if (checkMap[key]) {
        return checkMap[key](addCount);
      } else {
        addCount();
      }
    });
    if (result) {
      util.show(errMessage)
    }
  }  
}


$(document).ready(function() {

  function initData(user) {
    var data = {
      locale: locale(),
      domain0: location.hostname.match(/\w+\.\w+$/)
    };
    data.user = user;
    data.user.create = util.format(data.user.created);
    data.user.last = util.format(data.user.last);
    data.user.avatar = user.avatar;
    user.websitePrefix = '';
    if (user.website) {
      if (user.website.indexOf('http') == -1 && user.website.indexOf('//') == -1) {
        user.websitePrefix = '//'
      }
    }
    data.inFrame = inFrame;
    data.showBtn = user.status === 1;

    var html = homeTpl(data);
    $('body').append(html);
    init(data);
  }

  if (window.parent.enhancerInitData) {
    initData(window.parent.enhancerInitData);
    window.parent.enhancerInitData = null;
  } else {
    ajax({
      url: '/api/userinfo'
    }, function(res) {
      if (res.success) {
        initData(res.user);
      } else {
        util.show(res.message, 'error');
      }
    });
  }
  

  $('.header a.user-info').addClass('selected');


  /*
  var timer;
  $('.active-account').hover(function () {
    clearTimeout(timer);
    $('.mail-tip').show();
  }, function () {
    timer = setTimeout(function () {
      $('.mail-tip').hide();
    }, 2000);
  })
  */
});


// WEBPACK FOOTER //
// ./src/pages/detail/detail.js